import {Theme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(3, 2),
    display: "flex",
    alignItems: "center",
    gap: '.75rem',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    position: "relative",
  },
  formControl: {
    minWidth: 220,
    position: "relative",
  },
    bulkButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: '#db0001',
    color: '#fff',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: 8,
    padding: theme.spacing(1, 2.5),
    boxShadow: '0 4px 10px rgba(219, 0, 1, 0.25)',
    transition: 'all 0.2s ease',

    '&:hover': {
      backgroundColor: '#b80000',
      boxShadow: '0 6px 14px rgba(219, 0, 1, 0.35)',
    },

    '&:disabled': {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.common.white,
    },
  },
}))
